import * as actionCreators from 'client/redux/signup/actionCreators';
import { SIGNUP } from 'client/redux/signup/constants';

export const signup = form => dispatch => {
  return dispatch(actionCreators.signup(SIGNUP, form));
};
